import { render, staticRenderFns } from "./compRedPackLog.vue?vue&type=template&id=325738be"
import script from "./compRedPackLog.vue?vue&type=script&lang=js"
export * from "./compRedPackLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports